import React from "react";
import { string, oneOf, elementType, bool } from "prop-types";
import iconNames from "@insightfulscience/atomic-react/Icon/names";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { colorPropTypes } from "../props/sx";

const iconPrefix = "wrapper";

const legacyNames = new Map([
	["download", "arrow-to-bottom"],
	["cart", "shopping-cart"],
	["profile", "user-alt"],
	["arrow-long-left", "long-arrow-left"],
	["arrow-long-right", "long-arrow-right"],
	["arrow-left-2", "arrow-left"],
	["arrow-right-2", "arrow-right"],
]);

const Icon = ({
	name,
	size,
	className,
	Tag = "i",
	color,
	animate = false,
	spacing = { ...spacingProps },
	...props
}) => (
	<Tag
		className={classes(
			`${iconPrefix}-icon`,
			`${iconPrefix}-icon-${legacyNames.get(name) || name}`,
			size && `${iconPrefix}-icon--${size}`,
			animate && `${iconPrefix}-icon--animate`,
			color && `text-color-${color}`,
			...spacingClassName(spacing),
			className,
		)}
		{...props}
	/>
);

Icon.propTypes = {
	name: oneOf(iconNames).isRequired,
	size: oneOf(["xs", "s", "m", "l", "xl", "xxl", "xxxl", "xxxxl"]),
	color: colorPropTypes,
	animate: bool,
	className: string,
	spacing: spacingPropTypes,
	Tag: elementType,
};

export default pureFC(Icon);
